import { render } from "./PartnersClient.vue?vue&type=template&id=1c632641&scoped=true"
import script from "./PartnersClient.vue?vue&type=script&lang=js"
export * from "./PartnersClient.vue?vue&type=script&lang=js"

import "./PartnersClient.vue?vue&type=style&index=0&id=1c632641&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c632641"]])

export default __exports__